import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import Master from 'front/MasterAdmin';
import Grid from 'front/SubmissionGrid';
import React from 'react';


export const Submissions = (props: { archives?: boolean; }) => {

    return <Master>
        <Container maxWidth={false} sx={{ backgroundColor: props.archives ? '#FEE' : null }}>
            <Typography variant={'h1'}>{props.archives ? 'Archives' : 'Soumissions'}</Typography>
        </Container>
        <Grid archives={props.archives} />
    </Master>
        ;
};
